export const APP_ECONTRACT = window.runConfig.REACT_APP_ECONTRACT;

export const VI_LANG = 'vi';
